import axios from 'axios';
import { toError } from '@wix/da-shared-react/pkg/redux/errors';
import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-types-papi';

export const FETCH_LATEST_DEVIATIONS_SUCCESS =
  'FETCH_LATEST_DEVIATIONS_SUCCESS';
export const FETCH_MORE_LATEST_DEVIATIONS = 'FETCH_MORE_LATEST_DEVIATIONS';
export const FETCH_FEATURED_DEVIATIONS_SUCCESS =
  'FETCH_FEATURED_DEVIATIONS_SUCCESS';

export type UpdateCoverDeviationPayload = { deviation: PapiDeviation };
export const updateCoverDeviation = createAction<UpdateCoverDeviationPayload>(
  'UPDATE_COVER_DEVIATION'
);

export type UpdateCoverDeviationOffsetYPayload = { offsetY: number };
export const updateCoverDeviationOffsetY = createAction<
  UpdateCoverDeviationOffsetYPayload
>('UPDATE_COVER_DEVIATION_OFFSET_Y');

export const deleteCoverDeviation = createAction('DELETE_COVER_DEVIATION');

// TODO use redux-actions for all actions
export const fetchLatestDeviationsSuccess = (
  normalizedData: Record<string, any>
) => ({
  type: FETCH_LATEST_DEVIATIONS_SUCCESS,
  ...normalizedData,
});

export const fetchFeaturedDeviationsSuccess = (
  normalizedData: Record<string, any>
) => ({
  type: FETCH_FEATURED_DEVIATIONS_SUCCESS,
  ...normalizedData,
});

export const fetchMoreLatestDeviations = createAction(
  FETCH_MORE_LATEST_DEVIATIONS,
  (offset = 0) => ({
    offset,
    promise: axios
      // TODO: replace with real user-specific call
      .get('http://localhost:5003/papi/v1/dauserprofile/deviations/newest', {
        params: { offset },
      })
      .then(response => ({
        ...normalize(response.data.deviations, [deviationSchema]),
      }))
      .catch(toError),
  })
);
